import axios from "axios";
import { protectNames } from "@/lib/noTranslate";

export const API = "/api";

const TOKEN_KEY = "gs_token";
export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

const api = axios.create({ baseURL: API });
let onBehalf = null;
export function setOnBehalf(id) { onBehalf = id || null; }
let creditPrompt = null;
export function setCreditPrompt(fn) { creditPrompt = fn; }
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  if (onBehalf && config.method === "post" && config.url === "/listings") config.params = { ...(config.params || {}), per: onBehalf };
  return config;
});
api.interceptors.response.use((res) => {
  const u = res.config?.url || "";
  if (!/^\/(places|categories|i18n|rules|hero|home-ad|settings)/.test(u)) { try { protectNames(res.data); } catch { /* ignore */ } }
  return res;
}, async (err) => {
  const d = err?.response?.data?.detail;
  if (err?.response?.status === 402 && d && typeof d === "object") {
    const r = creditPrompt ? await creditPrompt(d) : null;
    if (r?.ok && d.code === "confirm") {
      const cfg = err.config;
      cfg.headers = { ...cfg.headers, "X-Credit-Confirm": "1", "X-Credit-Renew": r.renew ? "1" : "0" };
      return api.request(cfg);
    }
    err.response.data.detail = d.code === "confirm" ? "Publikimi u anulua" : d.message;
  }
  return Promise.reject(err);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Diçka shkoi keq. Provo përsëri.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export default api;
